import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import CommuneHero from './components/CommuneHero';
import CommuneSelector from './components/CommuneSelector';
import CommuneOverview from './components/CommuneOverview';
import LifestyleSection from './components/LifestyleSection';
import InfrastructureSection from './components/InfrastructureSection';
import InvestmentInsights from './components/InvestmentInsights';
import PropertyShowcase from './components/PropertyShowcase';
import ResidentReviews from './components/ResidentReviews';
import ImmersiveTours from './components/ImmersiveTours';

import EmptyState from '../../components/ui/EmptyState';


const CommuneExplorer = () => {
  const [selectedCommune, setSelectedCommune] = useState(null);
  const [tourStartTrigger, setTourStartTrigger] = useState(0);

  // Mock data for Abidjan communes
  const communes = [
    {
      id: 'cocody',
      name: 'Cocody',
      shortDescription: 'Quartier résidentiel haut de gamme avec universités',
      description: 'Commune résidentielle prestigieuse d\'Abidjan, réputée pour ses quartiers chics, ses institutions éducatives de renom et sa proximité avec les centres d\'affaires.',
      detailedDescription: `Cocody représente l'excellence résidentielle d'Abidjan, alliant modernité et tradition dans un cadre verdoyant exceptionnel. Cette commune abrite les plus prestigieuses résidences de la capitale économique, ainsi que les principales institutions éducatives du pays, notamment l'Université Félix Houphouët-Boigny.\n\nLe quartier se distingue par son architecture contemporaine, ses larges avenues arborées et ses espaces verts préservés. Les familles expatriées et les cadres supérieurs ivoiriens y trouvent un environnement sécurisé et des services de qualité internationale.`,heroImage: 'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes%20images/114.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcyBpbWFnZXMvMTE0LmpwZyIsImlhdCI6MTc1NzQxNjA2OSwiZXhwIjoxNzg4OTUyMDY5fQ.yHya8o1crvdskzhc01XE7Ttmhf2u4LwmJoeP-dcytfs',
      galleryImages: [
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/plateau/Mairie_de_Cocody,_Abidjan.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJwbGF0ZWF1L01haXJpZV9kZV9Db2NvZHksX0FiaWRqYW4uanBnIiwiaWF0IjoxNzU3NDE5OTY0LCJleHAiOjE3ODg5NTU5NjR9.tWh8ch3aDOFv4-BXwdY-0sZ9lk8h4DMA708LAmpicwg','https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/plateau/platooff.webp?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJwbGF0ZWF1L3BsYXRvb2ZmLndlYnAiLCJpYXQiOjE3NTc0MjAxMDMsImV4cCI6MTc4ODk1NjEwM30.Tg-Nl3gVpfuUZ-e1c10JPAEhXtBiHwmiTpJuwcWeo48','https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/plateau/vertscocody.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJwbGF0ZWF1L3ZlcnRzY29jb2R5LmpwZyIsImlhdCI6MTc1NzQxNzkwMCwiZXhwIjoxNzg4OTUzOTAwfQ.MDcj_3ms2z8KNPl3AcfmBcEJJ8MlZbOR_Zw28NuWcBI'
      ],
      population: '400,000 hab.',area: '155 km²',averagePrice: '45M FCFA/m²',
      qualityRating: 4.8,
      propertyCount: 1250,
      isPopular: true,
      keyFeatures: [
        'Université Félix Houphouët-Boigny','Quartiers résidentiels sécurisés','Centres commerciaux modernes','Espaces verts et parcs','Proximité du Plateau des affaires','Infrastructure routière excellente'
      ],
      coordinates: { lat: 5.3364, lng: -4.0267 },
      lifestyle: {
        dining: [
          { name: 'Restaurant Le Wafou', description: 'Cuisine ivoirienne raffinée' },
          { name: 'Chez Georges', description: 'Brasserie française authentique' },
          { name: 'Maquis Chez Tantine', description: 'Spécialités locales traditionnelles' }
        ],
        shopping: [
          { name: 'Centre Commercial Cap Sud', description: 'Shopping moderne et cinéma' },
          { name: 'Marché de Cocody', description: 'Produits frais et artisanat local' },
          { name: 'Galerie Cécile Fakhoury', description: 'Art contemporain africain' }
        ],
        entertainment: [
          { name: 'Cinéma Majestic', description: 'Films internationaux et locaux' },
          { name: 'Centre Culturel Français', description: 'Événements culturels variés' },
          { name: 'Parc de la Paix', description: 'Détente et activités familiales' }
        ],
        sports: [
          { name: 'Golf Club d\'Abidjan', description: 'Parcours 18 trous prestigieux' },
          { name: 'Tennis Club de Cocody', description: 'Courts professionnels' },
          { name: 'Piscine Olympique', description: 'Natation et sports aquatiques' }
        ]
      },
      dailyLifeImages: [
        {
          url: 'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/plateau/UFHB%20RCI.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJwbGF0ZWF1L1VGSEIgUkNJLnBuZyIsImlhdCI6MTc1NzQxOTM0MywiZXhwIjoxNzg4OTU1MzQzfQ.7dMo-3x6SvUKY469VNnUtAwdDgHCmy98-yJCVtAQRcE',
          caption: 'Université Félix Houphouët-Boigny',
          location: 'Campus principal'
        },
        {
          url: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop',
          caption: 'Quartier résidentiel moderne',
          location: 'Cocody Danga'
        },
        {
          url: 'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/plateau/ccromercial%20cooc.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJwbGF0ZWF1L2Njcm9tZXJjaWFsIGNvb2MuanBnIiwiaWF0IjoxNzU3NDE5NTcxLCJleHAiOjE3ODg5NTU1NzF9.W-IXKPGZo14gjhD30AWOKQzJzlgWcr88wJj20Cx7s1c',
          caption: 'Centre commercial Cap Sud',
          location: 'Zone commerciale'
        }
      ],
      infrastructure: {
        transport: [
          { name: 'Gare routière de Cocody', distance: '2 km', rating: 4.2 },
          { name: 'Station BRT Université', distance: '1.5 km', rating: 4.5 },
          { name: 'Aéroport International', distance: '25 km', rating: 4.0 }
        ],
        education: [
          { name: 'Université Félix Houphouët-Boigny', distance: '0.5 km', rating: 4.8 },
          { name: 'Lycée Technique de Cocody', distance: '1 km', rating: 4.3 },
          { name: 'École Internationale', distance: '2 km', rating: 4.6 }
        ],
        healthcare: [
          { name: 'CHU de Cocody', distance: '3 km', rating: 4.4 },
          { name: 'Clinique Internationale', distance: '1.5 km', rating: 4.7 },
          { name: 'Pharmacie Nouvelle', distance: '0.8 km', rating: 4.2 }
        ],
        utilities: [
          { name: 'Centre CIE Cocody', distance: '1 km', rating: 4.0 },
          { name: 'Agence SODECI', distance: '1.2 km', rating: 3.8 },
          { name: 'Bureau de Poste Principal', distance: '0.7 km', rating: 4.1 }
        ]
      },
      developmentProjects: [
        {
          name: 'Extension Université',
          description: 'Nouveaux campus et résidences étudiantes',
          status: 'En cours',
          budget: '50 Mds FCFA',
          completion: 'Décembre 2025'
        },
        {
          name: 'Parc Technologique',
          description: 'Hub innovation et startups',
          status: 'Planifié',
          budget: '75 Mds FCFA',
          completion: 'Juin 2026'
        },
        {
          name: 'Centre Commercial Riviera',
          description: 'Complex commercial et résidentiel',
          status: 'En cours',
          budget: '40 Mds FCFA',
          completion: 'Mars 2026'
        }
      ],
      commuteData: [
        { name: 'Plateau (Centre d\'affaires)', type: 'District financier', time: '25 min', mode: 'Voiture' },
        { name: 'Aéroport International', type: 'Transport', time: '35 min', mode: 'Taxi' },
        { name: 'Port Autonome', type: 'Zone industrielle', time: '40 min', mode: 'Transport' },
        { name: 'Marcory Zone 4', type: 'Quartier d\'affaires', time: '30 min', mode: 'BRT' }
      ],
      investment: {
        appreciation: '8.5%',
        rentalYield: '6.2%',
        averageSaleTime: '45 jours',
        rentalDemand: 'Très élevée',
        priceEvolution: [
          { year: '2020', price: 35 },
          { year: '2021', price: 38 },
          { year: '2022', price: 41 },
          { year: '2023', price: 43 },
          { year: '2024', price: 45 }
        ],
        propertyTypes: [
          { name: 'Villas', value: 35 },
          { name: 'Appartements', value: 40 },
          { name: 'Duplex', value: 15 },
          { name: 'Terrains', value: 10 }
        ],
        opportunities: [
          {
            type: 'Résidentiel',
            title: 'Quartier Universitaire',
            description: 'Forte demande étudiante et professeurs',
            estimatedROI: '12-15%'
          },
          {
            type: 'Commercial',
            title: 'Zone Cap Sud',
            description: 'Expansion commerciale continue',
            estimatedROI: '10-12%'
          },
          {
            type: 'Mixte',
            title: 'Riviera Extension',
            description: 'Nouveau développement intégré',
            estimatedROI: '15-18%'
          }
        ]
      },
      featuredProperties: [
        {
          title: 'Villa Moderne Riviera',
          location: 'Cocody Riviera, près université',
          image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop',
          price: 180000000,
          pricePerSqm: 450000,
          bedrooms: 4,
          bathrooms: 3,
          area: 400,
          status: 'À vendre',
          rating: 4.8,
          hasVideo: true
        },
        {
          title: 'Appartement Standing Danga',
          location: 'Cocody Danga, résidence sécurisée',
          image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop',
          price: 85000000,
          pricePerSqm: 425000,
          bedrooms: 3,
          bathrooms: 2,
          area: 200,
          status: 'À vendre',
          rating: 4.6,
          hasVideo: false
        },
        {
          title: 'Duplex Angré Château',
          location: 'Cocody Angré, quartier calme',
          image: 'https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=600&h=400&fit=crop',
          price: 3500000,
          bedrooms: 2,
          bathrooms: 2,
          area: 150,
          status: 'À louer',
          rating: 4.7,
          hasVideo: true
        }
      ],
      propertyTypes: [
        {
          name: 'Villas de Luxe',
          description: 'Résidences haut de gamme avec jardins',
          icon: 'Home',
          count: 450,
          startingPrice: 120000000
        },
        {
          name: 'Appartements',
          description: 'Standing moderne en résidence',
          icon: 'Building',
          count: 680,
          startingPrice: 45000000
        },
        {
          name: 'Duplex',
          description: 'Espaces optimisés sur deux niveaux',
          icon: 'Building2',
          count: 120,
          startingPrice: 75000000
        },
        {
          name: 'Terrains',
          description: 'Parcelles viabilisées pour construction',
          icon: 'Square',
          count: 85,
          startingPrice: 25000000
        }
      ],
      reviews: [
        {
          name: 'Marie-Claire Kouassi',
          profile: 'Professeure d\'université, résidente depuis 8 ans',
          avatar: '######',
          rating: 5,
          date: '15 août 2025',
          category: 'professionals',
          comment: `Cocody offre un cadre de vie exceptionnel pour les familles. La proximité de l'université est un atout majeur, et les infrastructures sont de qualité. Les espaces verts sont bien entretenus et la sécurité est rassurante. Je recommande particulièrement le quartier Riviera pour son calme et sa modernité.`,
          tags: ['Sécurité', 'Éducation', 'Espaces verts', 'Transport'],
          helpful: 24
        },
        {
          name: 'Jean-Baptiste Traoré',profile: 'Cadre bancaire, famille avec 2 enfants',avatar: '#####',rating: 4,date: '10 août 2025',category: 'families',comment: `Excellent quartier pour élever des enfants. Les écoles sont de bon niveau et les activités ne manquent pas. Le seul bémol reste la circulation aux heures de pointe, mais les nouveaux projets d'infrastructure devraient améliorer la situation.`,
          tags: ['Famille', 'Écoles', 'Activités', 'Circulation'],
          helpful: 18
        },
        {
          name: 'Aminata Diallo',
          profile: 'Étudiante en master, logement partagé',
          avatar: '######',
          rating: 5,
          date: '5 août 2025',
          category: 'students',
          comment: `Parfait pour les étudiants ! Proche de l'université, bien desservi par les transports, et l'ambiance est dynamique. Les prix des logements étudiants restent accessibles et il y a beaucoup d'activités culturelles.`,
          tags: ['Université', 'Transport', 'Culture', 'Prix abordable'],
          helpful: 31
        }
      ]
    },
    {
      id: 'plateau',name: 'Plateau',shortDescription: 'Centre d\'affaires et administratif d\'Abidjan',
      description: 'Cœur économique et administratif d\'Abidjan, le Plateau concentre les sièges sociaux, institutions financières et bâtiments gouvernementaux.',
      detailedDescription: `Le Plateau est le poumon économique d'Abidjan et de toute la Côte d'Ivoire. Ce district financier concentre les plus grandes banques, compagnies d'assurance, sièges sociaux multinationaux et institutions gouvernementales du pays.\n\nAvec son architecture moderne et ses gratte-ciels emblématiques, le Plateau offre un environnement professionnel de premier plan. La Tour Abidjan, les immeubles de la BCEAO et les ambassades étrangères témoignent du rayonnement international de ce quartier d'affaires.`,
      heroImage: 'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/PLATEAU11.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvUExBVEVBVTExLlBORyIsInNjb3BlIjoiZG93bmxvYWQiLCJpYXQiOjE3ODIyMjIyMTMsImV4cCI6MTgxMzc1ODIxM30.Ddw5f43UuNqMpr1H9JFuuQfIzKRs4q_dLdH-THKzgVc',
      galleryImages: [
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/PLATEAU.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvUExBVEVBVS5QTkciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzgyMjIyMjkwLCJleHAiOjE4MTM3NTgyOTB9.jmoMRBfQr7jpQQMR-IqZLQoSTysaCfKeAn62cDwhcY0',
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/PLATEOO.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvUExBVEVPTy5QTkciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzgyMjIyMzQxLCJleHAiOjE4MTM3NTgzNDF9.YTi-uDmUqO2wB-e3v9XhtL1hLCBxB2SK6qdLG3rD8Iw',
        'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=600&h=400&fit=crop'
      ],
      population: '20,000 hab.',
      area: '3 km²',
      averagePrice: '60M FCFA/m²',
      qualityRating: 4.7,
      propertyCount: 890,
      isPopular: true,
      keyFeatures: [
        'District financier principal','Sièges sociaux internationaux','Institutions gouvernementales','Connexions transport excellentes','Restaurants et hôtels de luxe','Architecture moderne emblématique'
      ],
      coordinates: { lat: 5.3196, lng: -4.0167 },
      lifestyle: {
        dining: [
          { name: 'Restaurant La Pergola', description: 'Cuisine internationale haut de gamme' },
          { name: 'Brasserie du Plateau', description: 'Déjeuners d\'affaires raffinés' },
          { name: 'Café de la Paix', description: 'Café et snacks pour professionnels' }
        ],
        shopping: [
          { name: 'Centre Commercial Plateau', description: 'Boutiques et services professionnels' },
          { name: 'Galerie Marchande BCEAO', description: 'Commerces de proximité' },
          { name: 'Librairie de France', description: 'Livres et fournitures de bureau' }
        ],
        entertainment: [
          { name: 'Palais de la Culture', description: 'Spectacles et expositions' },
          { name: 'Hôtel Ivoire', description: 'Casino et loisirs de luxe' },
          { name: 'Jardin du Plateau', description: 'Espace vert central' }
        ],
        sports: [
          { name: 'Salle de sport Executive', description: 'Fitness pour cadres' },
          { name: 'Piscine Hôtel Ivoire', description: 'Natation et détente' },
          { name: 'Jogging Bord de Lagune', description: 'Parcours sportif en plein air' }
        ]
      },
      dailyLifeImages: [
        { url: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&h=400&fit=crop', caption: 'Skyline du Plateau', location: 'Centre d\'affaires' },
        { url: 'https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=600&h=400&fit=crop', caption: 'Immeubles de bureaux modernes', location: 'Zone financière' },
        { url: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=600&h=400&fit=crop', caption: 'Vue panoramique sur la lagune', location: 'Bord de lagune' }
      ],
      infrastructure: {
        transport: [
          { name: 'Gare de Treichville', distance: '1 km', rating: 4.3 },
          { name: 'Terminal Ferry Plateau', distance: '0.5 km', rating: 4.6 },
          { name: 'Aéroport International', distance: '20 km', rating: 4.0 }
        ],
        education: [
          { name: 'École Nationale d\'Administration', distance: '0.8 km', rating: 4.7 },
          { name: 'Institut National Polytechnique', distance: '2 km', rating: 4.5 },
          { name: 'Lycée Classique d\'Abidjan', distance: '1.5 km', rating: 4.4 }
        ],
        healthcare: [
          { name: 'Clinique du Plateau', distance: '0.5 km', rating: 4.6 },
          { name: 'Pharmacie Centrale', distance: '0.3 km', rating: 4.5 },
          { name: 'Cabinet Médical International', distance: '0.7 km', rating: 4.8 }
        ],
        utilities: [
          { name: 'CIE Siège Social', distance: '0.5 km', rating: 4.2 },
          { name: 'SODECI Direction', distance: '0.8 km', rating: 4.0 },
          { name: 'Poste Centrale', distance: '0.4 km', rating: 4.3 }
        ]
      },
      developmentProjects: [
        { name: 'Tour Abidjan Phase 2', description: 'Extension du complexe de bureaux', status: 'En cours', budget: '120 Mds FCFA', completion: 'Décembre 2026' },
        { name: 'Rénovation Bord de Lagune', description: 'Promenade et espaces verts', status: 'Planifié', budget: '30 Mds FCFA', completion: 'Juin 2026' },
        { name: 'Smart City Plateau', description: 'Infrastructure numérique avancée', status: 'En cours', budget: '60 Mds FCFA', completion: 'Mars 2027' }
      ],
      commuteData: [
        { name: 'Cocody', type: 'Résidentiel', time: '25 min', mode: 'Voiture' },
        { name: 'Treichville', type: 'Commercial', time: '10 min', mode: 'Ferry' },
        { name: 'Aéroport International', type: 'Transport', time: '30 min', mode: 'Taxi' },
        { name: 'Marcory Zone 4', type: 'Résidentiel', time: '20 min', mode: 'BRT' }
      ],
      investment: {
        appreciation: '9.2%',
        rentalYield: '7.5%',
        averageSaleTime: '30 jours',
        rentalDemand: 'Très élevée',
        priceEvolution: [
          { year: '2020', price: 45 },
          { year: '2021', price: 50 },
          { year: '2022', price: 55 },
          { year: '2023', price: 58 },
          { year: '2024', price: 60 }
        ],
        propertyTypes: [
          { name: 'Bureaux', value: 55 },
          { name: 'Appartements', value: 30 },
          { name: 'Commerces', value: 15 }
        ],
        opportunities: [
          { type: 'Commercial', title: 'Immobilier de Bureaux', description: 'Forte demande de cadres et multinationales', estimatedROI: '14-18%' },
          { type: 'Résidentiel', title: 'Appartements Haut Standing', description: 'Rareté du foncier = valorisation garantie', estimatedROI: '10-13%' },
          { type: 'Mixte', title: 'Complexes Mixtes', description: 'Bureaux + résidentiel en forte demande', estimatedROI: '12-16%' }
        ]
      },
      featuredProperties: [
        { title: 'Bureau Prestige Tour Abidjan', location: 'Plateau Centre, vue lagune', image: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&h=400&fit=crop', price: 350000000, pricePerSqm: 700000, bedrooms: 0, bathrooms: 2, area: 500, status: 'À vendre', rating: 4.9, hasVideo: false },
        { title: 'Appartement Cadre Supérieur', location: 'Plateau, vue panoramique', image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop', price: 120000000, pricePerSqm: 600000, bedrooms: 3, bathrooms: 2, area: 200, status: 'À vendre', rating: 4.7, hasVideo: false },
        { title: 'Studio Professionnel', location: 'Plateau, centre d\'affaires', image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop', price: 2500000, bedrooms: 1, bathrooms: 1, area: 60, status: 'À louer', rating: 4.5, hasVideo: false }
      ],
      propertyTypes: [
        { name: 'Bureaux', description: 'Espaces professionnels modernes', icon: 'Building', count: 420, startingPrice: 150000000 },
        { name: 'Appartements', description: 'Résidences haut standing', icon: 'Home', count: 310, startingPrice: 80000000 },
        { name: 'Commerces', description: 'Locaux commerciaux stratégiques', icon: 'Store', count: 160, startingPrice: 50000000 }
      ],
      reviews: [
        { name: 'Kofi Mensah', profile: 'Directeur financier, résident depuis 5 ans', avatar: '##', rating: 5, date: '12 août 2025', category: 'professionals', comment: 'Le Plateau est l\'adresse idéale pour les professionnels. Tout est accessible à pied, les restaurants d\'affaires sont excellents et le prestige de l\'adresse est inégalé à Abidjan.', tags: ['Affaires', 'Prestige', 'Accessibilité'], helpful: 19 },
        { name: 'Sophie Ouattara', profile: 'Avocate d\'affaires, célibataire', avatar: '##', rating: 4, date: '8 août 2025', category: 'professionals', comment: 'Quartier très pratique pour travailler. Seul inconvénient : les embouteillages le soir. Mais la qualité des services et la sécurité sont au top.', tags: ['Travail', 'Sécurité', 'Services'], helpful: 14 }
      ]
    },
    {
      id: 'marcory',
      name: 'Marcory',
      shortDescription: 'Zone industrielle et résidentielle en développement',
      description: 'Commune en pleine transformation, alliant zones industrielles et nouveaux quartiers résidentiels modernes.',
      detailedDescription: `Marcory est une commune en pleine mutation, symbole du dynamisme économique d'Abidjan. Connue pour sa Zone 4, quartier d'affaires et de loisirs très prisé, Marcory attire aussi bien les familles que les investisseurs en quête d'opportunités.\n\nLa commune bénéficie d'une position géographique stratégique entre le Plateau et les communes sud d'Abidjan. Son tissu industriel solide cohabite avec des quartiers résidentiels modernes en plein essor, offrant un excellent rapport qualité-prix pour l'immobilier.`,
      heroImage: 'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/MARCORY.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvTUFSQ09SWS5QTkciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzgyMjIyNjk2LCJleHAiOjE4MTM3NTg2OTZ9.rVJGXF0WDaJAmESoWuVxW2kUl3YhfzV6qwf43vkE0QA',
      galleryImages: [
        'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&h=400&fit=crop',
        'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop',
        'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop'
      ],
      population: '250,000 hab.',
      area: '25 km²',
      averagePrice: '28M FCFA/m²',
      qualityRating: 4.2,
      propertyCount: 650,
      isPopular: false,
      keyFeatures: [
        'Zone 4 quartier d\'affaires','Industries et zones franches','Nouveaux complexes résidentiels','Accès rapide au Plateau','Marchés et commerces animés','Projets de rénovation urbaine'
      ],
      coordinates: { lat: 5.3000, lng: -3.9833 },
      lifestyle: {
        dining: [
          { name: 'Maquis Zone 4', description: 'Cuisine ivoirienne populaire' },
          { name: 'Restaurant Le Diplomate', description: 'Cuisine internationale' },
          { name: 'Fast Food Marcory', description: 'Restauration rapide locale' }
        ],
        shopping: [
          { name: 'Marché de Marcory', description: 'Produits frais et textiles' },
          { name: 'Centre Commercial Zone 4', description: 'Boutiques et services' },
          { name: 'Supermarché Sococé', description: 'Grande surface moderne' }
        ],
        entertainment: [
          { name: 'Stade Robert Champroux', description: 'Événements sportifs' },
          { name: 'Bars et Clubs Zone 4', description: 'Vie nocturne animée' },
          { name: 'Cinéma Liberté', description: 'Films et divertissements' }
        ],
        sports: [
          { name: 'Stade de Marcory', description: 'Football et athlétisme' },
          { name: 'Salle de Fitness Zone 4', description: 'Musculation et cardio' },
          { name: 'Terrain de Basketball', description: 'Sports collectifs' }
        ]
      },
      dailyLifeImages: [
        { url: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&h=400&fit=crop', caption: 'Zone industrielle de Marcory', location: 'Zone industrielle' },
        { url: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop', caption: 'Quartier résidentiel moderne', location: 'Zone 4' },
        { url: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop', caption: 'Appartements en développement', location: 'Nouveau quartier' }
      ],
      infrastructure: {
        transport: [
          { name: 'Gare routière de Marcory', distance: '1.5 km', rating: 4.0 },
          { name: 'Station BRT Marcory', distance: '1 km', rating: 4.2 },
          { name: 'Aéroport International', distance: '15 km', rating: 4.0 }
        ],
        education: [
          { name: 'Lycée de Marcory', distance: '1 km', rating: 4.1 },
          { name: 'École Primaire Publique', distance: '0.5 km', rating: 3.9 },
          { name: 'Institut de Formation Pro', distance: '2 km', rating: 4.3 }
        ],
        healthcare: [
          { name: 'Hôpital de Marcory', distance: '2 km', rating: 4.0 },
          { name: 'Clinique Sainte Marie', distance: '1.5 km', rating: 4.3 },
          { name: 'Pharmacie Zone 4', distance: '0.5 km', rating: 4.1 }
        ],
        utilities: [
          { name: 'Agence CIE Marcory', distance: '1 km', rating: 3.9 },
          { name: 'SODECI Marcory', distance: '1.2 km', rating: 3.8 },
          { name: 'Bureau de Poste', distance: '0.8 km', rating: 4.0 }
        ]
      },
      developmentProjects: [
        { name: 'Réhabilitation Zone Industrielle', description: 'Modernisation des infrastructures', status: 'En cours', budget: '45 Mds FCFA', completion: 'Juin 2026' },
        { name: 'Résidences Zone 4 Extension', description: 'Nouveaux logements modernes', status: 'Planifié', budget: '35 Mds FCFA', completion: 'Décembre 2026' },
        { name: 'Voie Express Marcory', description: 'Désengorgement du trafic', status: 'En cours', budget: '25 Mds FCFA', completion: 'Mars 2026' }
      ],
      commuteData: [
        { name: 'Plateau', type: 'Centre d\'affaires', time: '20 min', mode: 'Voiture' },
        { name: 'Treichville', type: 'Commercial', time: '10 min', mode: 'Taxi' },
        { name: 'Aéroport International', type: 'Transport', time: '20 min', mode: 'Taxi' },
        { name: 'Port Autonome', type: 'Zone industrielle', time: '15 min', mode: 'Voiture' }
      ],
      investment: {
        appreciation: '7.2%',
        rentalYield: '6.8%',
        averageSaleTime: '55 jours',
        rentalDemand: 'Élevée',
        priceEvolution: [
          { year: '2020', price: 20 },
          { year: '2021', price: 22 },
          { year: '2022', price: 24 },
          { year: '2023', price: 26 },
          { year: '2024', price: 28 }
        ],
        propertyTypes: [
          { name: 'Appartements', value: 45 },
          { name: 'Maisons', value: 30 },
          { name: 'Commerces', value: 15 },
          { name: 'Terrains', value: 10 }
        ],
        opportunities: [
          { type: 'Résidentiel', title: 'Zone 4 Résidentielle', description: 'Forte demande locative des travailleurs', estimatedROI: '10-13%' },
          { type: 'Commercial', title: 'Locaux Industriels', description: 'Demande soutenue des PME', estimatedROI: '9-12%' },
          { type: 'Mixte', title: 'Développement Mixte', description: 'Potentiel de valorisation important', estimatedROI: '11-15%' }
        ]
      },
      featuredProperties: [
        { title: 'Appartement Zone 4 Moderne', location: 'Marcory Zone 4, résidence gardée', image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop', price: 55000000, pricePerSqm: 275000, bedrooms: 3, bathrooms: 2, area: 200, status: 'À vendre', rating: 4.4, hasVideo: false },
        { title: 'Villa Familiale Marcory', location: 'Marcory Résidentiel, quartier calme', image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop', price: 95000000, pricePerSqm: 317000, bedrooms: 4, bathrooms: 3, area: 300, status: 'À vendre', rating: 4.3, hasVideo: false },
        { title: 'Studio Meublé Zone 4', location: 'Marcory Zone 4, proche commerces', image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop', price: 1800000, bedrooms: 1, bathrooms: 1, area: 50, status: 'À louer', rating: 4.2, hasVideo: false }
      ],
      propertyTypes: [
        { name: 'Appartements', description: 'Logements modernes en résidence', icon: 'Building', count: 280, startingPrice: 35000000 },
        { name: 'Maisons', description: 'Maisons familiales avec cour', icon: 'Home', count: 220, startingPrice: 60000000 },
        { name: 'Commerces', description: 'Locaux commerciaux et industriels', icon: 'Store', count: 150, startingPrice: 20000000 }
      ],
      reviews: [
        { name: 'Aya Bamba', profile: 'Commerçante, résidente depuis 10 ans', avatar: '##', rating: 4, date: '14 août 2025', category: 'professionals', comment: 'Marcory est une commune dynamique avec beaucoup d\'opportunités commerciales. La Zone 4 est très animée et les prix de l\'immobilier restent accessibles comparé à Cocody.', tags: ['Commerce', 'Accessibilité', 'Dynamisme'], helpful: 16 },
        { name: 'Paul Koffi', profile: 'Ingénieur, famille avec 3 enfants', avatar: '##', rating: 4, date: '9 août 2025', category: 'families', comment: 'Bonne commune pour les familles avec un budget moyen. Les écoles sont correctes et les marchés bien approvisionnés. Les projets de développement en cours vont améliorer le cadre de vie.', tags: ['Famille', 'Budget', 'Développement'], helpful: 12 }
      ]
    },
    {
      id: 'treichville',
      name: 'Treichville',
      shortDescription: 'Quartier populaire et culturel authentique',
      description: 'Berceau de la culture urbaine ivoirienne, quartier vivant avec marchés traditionnels et vie nocturne animée.',
      detailedDescription: `Treichville est l'âme populaire d'Abidjan, un quartier vibrant qui incarne l'authenticité et la vitalité de la culture ivoirienne. Situé sur une presqu'île entre la lagune Ébrié et le port, ce quartier historique est le berceau de nombreuses traditions musicales et artistiques du pays.\n\nLe marché de Treichville, l'un des plus grands d'Afrique de l'Ouest, attire des commerçants et acheteurs de toute la région. La vie nocturne légendaire du quartier, avec ses maquis et clubs de musique, en fait une destination incontournable pour les amateurs de culture urbaine africaine.`,heroImage: 'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/TREICHV.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvVFJFSUNIVi5qcGciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzgyMjIyODM5LCJleHAiOjE4MTM3NTg4Mzl9.3tUjwwFFVTADV2AhAVaPw2P8pESNs7FeRa605huKg-s',
      galleryImages: [
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/TREICHVILL.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvVFJFSUNIVklMTC5QTkciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzgyMjIyODc5LCJleHAiOjE4MTM3NTg4Nzl9.bByZrzpic6RUqlhx-k0EFZBvcH31hekeJdPnGrCVF_A','https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/TREICHVILLE.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvVFJFSUNIVklMTEUuUE5HIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4MjIyMjkyMywiZXhwIjoxODEzNzU4OTIzfQ._GWX0hPOCPVia3alImVcqkEHjgZ_PV73ttdkkLVa2X0','https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/TREICHVILLE.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvVFJFSUNIVklMTEUuUE5HIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4MjIyMjkyMywiZXhwIjoxODEzNzU4OTIzfQ._GWX0hPOCPVia3alImVcqkEHjgZ_PV73ttdkkLVa2X0'
      ],
      population: '180,000 hab.',area: '8 km²',averagePrice: '18M FCFA/m²',
      qualityRating: 3.9,
      propertyCount: 420,
      isPopular: false,
      keyFeatures: [
        'Grand marché traditionnel','Vie nocturne et culture musicale','Proximité du port autonome','Gastronomie ivoirienne authentique','Artisanat et commerce local','Accès ferry vers le Plateau'
      ],
      coordinates: { lat: 5.2989, lng: -4.0089 },
      lifestyle: {
        dining: [
          { name: 'Maquis Chez Tantie Adjoua', description: 'Attiéké poisson et spécialités locales' },
          { name: 'Restaurant du Port', description: 'Fruits de mer frais du jour' },
          { name: 'Grillade de Treichville', description: 'Brochettes et grillades populaires' }
        ],
        shopping: [
          { name: 'Grand Marché de Treichville', description: 'Tout en un seul endroit' },
          { name: 'Marché aux Tissus', description: 'Wax et pagnes africains' },
          { name: 'Marché de Nuit', description: 'Commerce nocturne animé' }
        ],
        entertainment: [
          { name: 'Maquis Culturels', description: 'Musique live et danse' },
          { name: 'Stade de Treichville', description: 'Matchs de football populaires' },
          { name: 'Clubs de Nuit', description: 'Coupé-décalé et afrobeats' }
        ],
        sports: [
          { name: 'Stade Municipal', description: 'Football et sports collectifs' },
          { name: 'Terrain de Pétanque', description: 'Loisir populaire local' },
          { name: 'Bord de Lagune', description: 'Pêche et promenades' }
        ]
      },
      dailyLifeImages: [
        { url: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=600&h=400&fit=crop', caption: 'Marché animé de Treichville', location: 'Grand Marché' },
        { url: 'https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=600&h=400&fit=crop', caption: 'Vie nocturne et culture', location: 'Quartier des maquis' },
        { url: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=600&h=400&fit=crop', caption: 'Bord de lagune', location: 'Front de mer' }
      ],
      infrastructure: {
        transport: [
          { name: 'Gare Ferry Treichville', distance: '0.5 km', rating: 4.4 },
          { name: 'Gare Routière Sud', distance: '1 km', rating: 4.0 },
          { name: 'Port Autonome', distance: '2 km', rating: 4.2 }
        ],
        education: [
          { name: 'Lycée de Treichville', distance: '1 km', rating: 3.9 },
          { name: 'École Primaire Centrale', distance: '0.5 km', rating: 3.8 },
          { name: 'Centre de Formation Pro', distance: '1.5 km', rating: 4.0 }
        ],
        healthcare: [
          { name: 'Hôpital Général de Treichville', distance: '1.5 km', rating: 3.9 },
          { name: 'Dispensaire Municipal', distance: '0.8 km', rating: 3.7 },
          { name: 'Pharmacie du Marché', distance: '0.3 km', rating: 4.0 }
        ],
        utilities: [
          { name: 'Agence CIE Treichville', distance: '1 km', rating: 3.7 },
          { name: 'SODECI Treichville', distance: '1.2 km', rating: 3.6 },
          { name: 'Bureau de Poste', distance: '0.6 km', rating: 3.9 }
        ]
      },
      developmentProjects: [
        { name: 'Rénovation Grand Marché', description: 'Modernisation des infrastructures commerciales', status: 'Planifié', budget: '20 Mds FCFA', completion: 'Décembre 2026' },
        { name: 'Réhabilitation Logements', description: 'Amélioration du parc immobilier', status: 'En cours', budget: '15 Mds FCFA', completion: 'Juin 2026' },
        { name: 'Promenade Bord de Lagune', description: 'Aménagement touristique et culturel', status: 'Planifié', budget: '10 Mds FCFA', completion: 'Mars 2027' }
      ],
      commuteData: [
        { name: 'Plateau', type: 'Centre d\'affaires', time: '10 min', mode: 'Ferry' },
        { name: 'Marcory', type: 'Résidentiel', time: '10 min', mode: 'Taxi' },
        { name: 'Port Autonome', type: 'Zone industrielle', time: '5 min', mode: 'Voiture' },
        { name: 'Aéroport', type: 'Transport', time: '25 min', mode: 'Taxi' }
      ],
      investment: {
        appreciation: '5.8%',
        rentalYield: '7.2%',
        averageSaleTime: '70 jours',
        rentalDemand: 'Modérée',
        priceEvolution: [
          { year: '2020', price: 14 },
          { year: '2021', price: 15 },
          { year: '2022', price: 16 },
          { year: '2023', price: 17 },
          { year: '2024', price: 18 }
        ],
        propertyTypes: [
          { name: 'Maisons', value: 50 },
          { name: 'Appartements', value: 25 },
          { name: 'Commerces', value: 25 }
        ],
        opportunities: [
          { type: 'Commercial', title: 'Locaux Commerciaux Marché', description: 'Flux commercial intense et constant', estimatedROI: '12-15%' },
          { type: 'Résidentiel', title: 'Logements Locatifs', description: 'Forte demande des travailleurs du port', estimatedROI: '8-11%' },
          { type: 'Touristique', title: 'Hébergement Culturel', description: 'Tourisme culturel en développement', estimatedROI: '9-12%' }
        ]
      },
      featuredProperties: [
        { title: 'Maison Traditionnelle Rénovée', location: 'Treichville Centre, proche marché', image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop', price: 40000000, pricePerSqm: 200000, bedrooms: 3, bathrooms: 2, area: 200, status: 'À vendre', rating: 4.0, hasVideo: false },
        { title: 'Local Commercial Marché', location: 'Grand Marché de Treichville', image: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&h=400&fit=crop', price: 25000000, pricePerSqm: 250000, bedrooms: 0, bathrooms: 1, area: 100, status: 'À vendre', rating: 4.2, hasVideo: false },
        { title: 'Appartement Bord de Lagune', location: 'Treichville, vue lagune', image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop', price: 1200000, bedrooms: 2, bathrooms: 1, area: 80, status: 'À louer', rating: 3.9, hasVideo: false }
      ],
      propertyTypes: [
        { name: 'Maisons', description: 'Habitations traditionnelles et rénovées', icon: 'Home', count: 200, startingPrice: 25000000 },
        { name: 'Commerces', description: 'Locaux dans le grand marché', icon: 'Store', count: 150, startingPrice: 15000000 },
        { name: 'Appartements', description: 'Logements modernes en immeuble', icon: 'Building', count: 70, startingPrice: 20000000 }
      ],
      reviews: [
        { name: 'Fatou Coulibaly', profile: 'Commerçante, native de Treichville', avatar: '##', rating: 4, date: '11 août 2025', category: 'professionals', comment: 'Treichville c\'est l\'âme d\'Abidjan ! Le marché est incroyable, on trouve tout. La vie de quartier est chaleureuse et authentique. Certes ce n\'est pas le quartier le plus chic, mais c\'est le plus vivant.', tags: ['Authenticité', 'Commerce', 'Vie de quartier'], helpful: 22 },
        { name: 'Moussa Traoré', profile: 'Artiste musicien, résident depuis 15 ans', avatar: '##', rating: 5, date: '6 août 2025', category: 'professionals', comment: 'Pour la culture et la musique, Treichville est unique. C\'est ici que le coupé-décalé est né. L\'énergie du quartier est incomparable et l\'immobilier reste très accessible.', tags: ['Culture', 'Musique', 'Accessibilité'], helpful: 28 }
      ]
    },
    {
      id: 'adjame',
      name: 'Adjamé',
      shortDescription: 'Hub commercial et de transport majeur',
      description: 'Centre névralgique du commerce et des transports, avec le plus grand marché d\'Afrique de l\'Ouest.',
      detailedDescription: `Adjamé est le carrefour commercial et de transport d'Abidjan, une commune bouillonnante d'activité qui ne dort jamais. Son marché Adjamé, l'un des plus grands d'Afrique de l'Ouest, attire chaque jour des milliers de commerçants et acheteurs de toute la sous-région.\n\nLa commune abrite également la plus grande gare routière d'Abidjan, point de départ de milliers de voyageurs quotidiens. Malgré son image populaire, Adjamé connaît une transformation progressive avec de nouveaux projets immobiliers et la modernisation de ses infrastructures commerciales.`,
      heroImage: 'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/ADJAME.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvQURKQU1FLlBORyIsInNjb3BlIjoiZG93bmxvYWQiLCJpYXQiOjE3ODIyMjUyMjcsImV4cCI6MTgxMzc2MTIyN30.JHcsReJYE7ljQL_Q400D2SsD14ra8g9hf6tPZ_wOqt4',
      galleryImages: [
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/ADJAMEE.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvQURKQU1FRS5QTkciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzgyMjI1MjgxLCJleHAiOjE4MTM3NjEyODF9.LWiT17h0EZ9rTZIeQrHLdefZibLAtujuDLaDL3L6TAA',
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/ADJAMEE.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvQURKQU1FRS5QTkciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzgyMjI1MjgxLCJleHAiOjE4MTM3NjEyODF9.LWiT17h0EZ9rTZIeQrHLdefZibLAtujuDLaDL3L6TAA',
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/ADJAMEE.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvQURKQU1FRS5QTkciLCJzY29wZSI6ImRvd25sb2FkIiwiaWF0IjoxNzgyMjI1MjgxLCJleHAiOjE4MTM3NjEyODF9.LWiT17h0EZ9rTZIeQrHLdefZibLAtujuDLaDL3L6TAA'
      ],
      population: '350,000 hab.',
      area: '12 km²',
      averagePrice: '15M FCFA/m²',
      qualityRating: 3.7,
      propertyCount: 380,
      isPopular: false,
      keyFeatures: [
        'Plus grand marché d\'Afrique de l\'Ouest','Gare routière internationale','Hub de transport majeur','Commerce en gros et détail','Pharmacies et médecine traditionnelle','Tissu social très diversifié'
      ],
      coordinates: { lat: 5.3567, lng: -4.0167 },
      lifestyle: {
        dining: [
          { name: 'Maquis Populaires Adjamé', description: 'Cuisine de rue authentique' },
          { name: 'Restaurant Sénégalais', description: 'Thiéboudienne et spécialités' },
          { name: 'Grillade du Marché', description: 'Brochettes et alloco' }
        ],
        shopping: [
          { name: 'Marché Adjamé', description: 'Le plus grand marché de la région' },
          { name: 'Marché aux Médicaments', description: 'Pharmacopée traditionnelle' },
          { name: 'Grossistes Textiles', description: 'Tissus en gros à prix imbattables' }
        ],
        entertainment: [
          { name: 'Cinéma Liberté', description: 'Films populaires locaux' },
          { name: 'Terrains de Sport', description: 'Football de quartier' },
          { name: 'Espaces Culturels', description: 'Événements communautaires' }
        ],
        sports: [
          { name: 'Terrain Municipal', description: 'Football et sports collectifs' },
          { name: 'Salle Communautaire', description: 'Arts martiaux et fitness' },
          { name: 'Parc Adjamé', description: 'Jogging et détente' }
        ]
      },
      dailyLifeImages: [
        { url: 'https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=600&h=400&fit=crop', caption: 'Animation du marché Adjamé', location: 'Grand Marché' },
        { url: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=600&h=400&fit=crop', caption: 'Gare routière internationale', location: 'Gare d\'Adjamé' },
        { url: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=600&h=400&fit=crop', caption: 'Commerce de rue animé', location: 'Centre Adjamé' }
      ],
      infrastructure: {
        transport: [
          { name: 'Gare Routière Adjamé', distance: '0.5 km', rating: 4.5 },
          { name: 'Terminal Bus Interurbain', distance: '0.8 km', rating: 4.3 },
          { name: 'Station Taxi Collectif', distance: '0.2 km', rating: 4.0 }
        ],
        education: [
          { name: 'Lycée Municipal Adjamé', distance: '1 km', rating: 3.8 },
          { name: 'École Primaire Publique', distance: '0.4 km', rating: 3.7 },
          { name: 'Centre de Formation', distance: '1.5 km', rating: 3.9 }
        ],
        healthcare: [
          { name: 'CHU d\'Adjamé', distance: '2 km', rating: 3.8 },
          { name: 'Dispensaire Municipal', distance: '1 km', rating: 3.6 },
          { name: 'Pharmacies du Marché', distance: '0.3 km', rating: 4.0 }
        ],
        utilities: [
          { name: 'Agence CIE Adjamé', distance: '1 km', rating: 3.6 },
          { name: 'SODECI Adjamé', distance: '1.3 km', rating: 3.5 },
          { name: 'Bureau de Poste', distance: '0.7 km', rating: 3.8 }
        ]
      },
      developmentProjects: [
        { name: 'Modernisation Marché Adjamé', description: 'Rénovation et structuration du marché', status: 'En cours', budget: '30 Mds FCFA', completion: 'Décembre 2026' },
        { name: 'Nouvelle Gare Routière', description: 'Terminal moderne et organisé', status: 'Planifié', budget: '50 Mds FCFA', completion: 'Juin 2027' },
        { name: 'Logements Sociaux Adjamé', description: 'Programme de logements abordables', status: 'En cours', budget: '40 Mds FCFA', completion: 'Mars 2026' }
      ],
      commuteData: [
        { name: 'Plateau', type: 'Centre d\'affaires', time: '15 min', mode: 'Taxi' },
        { name: 'Cocody', type: 'Résidentiel', time: '20 min', mode: 'Bus' },
        { name: 'Yopougon', type: 'Résidentiel', time: '25 min', mode: 'Gbaka' },
        { name: 'Abobo', type: 'Résidentiel', time: '20 min', mode: 'Woro-woro' }
      ],
      investment: {
        appreciation: '5.2%',
        rentalYield: '8.0%',
        averageSaleTime: '80 jours',
        rentalDemand: 'Élevée',
        priceEvolution: [
          { year: '2020', price: 11 },
          { year: '2021', price: 12 },
          { year: '2022', price: 13 },
          { year: '2023', price: 14 },
          { year: '2024', price: 15 }
        ],
        propertyTypes: [
          { name: 'Commerces', value: 45 },
          { name: 'Maisons', value: 35 },
          { name: 'Appartements', value: 20 }
        ],
        opportunities: [
          { type: 'Commercial', title: 'Locaux Marché', description: 'Rentabilité locative très élevée', estimatedROI: '14-18%' },
          { type: 'Résidentiel', title: 'Logements Locatifs', description: 'Forte demande des commerçants', estimatedROI: '9-12%' },
          { type: 'Entrepôts', title: 'Stockage et Logistique', description: 'Besoin croissant des grossistes', estimatedROI: '11-14%' }
        ]
      },
      featuredProperties: [
        { title: 'Local Commercial Marché Adjamé', location: 'Adjamé, cœur du marché', image: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&h=400&fit=crop', price: 30000000, pricePerSqm: 300000, bedrooms: 0, bathrooms: 1, area: 100, status: 'À vendre', rating: 4.1, hasVideo: false },
        { title: 'Maison Familiale Adjamé', location: 'Adjamé Résidentiel', image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop', price: 35000000, pricePerSqm: 175000, bedrooms: 4, bathrooms: 2, area: 200, status: 'À vendre', rating: 3.9, hasVideo: false },
        { title: 'Chambre Meublée Adjamé', location: 'Adjamé Centre, proche gare', image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop', price: 800000, bedrooms: 1, bathrooms: 1, area: 30, status: 'À louer', rating: 3.8, hasVideo: false }
      ],
      propertyTypes: [
        { name: 'Commerces', description: 'Locaux dans le grand marché', icon: 'Store', count: 180, startingPrice: 15000000 },
        { name: 'Maisons', description: 'Habitations familiales', icon: 'Home', count: 140, startingPrice: 20000000 },
        { name: 'Appartements', description: 'Logements en immeuble', icon: 'Building', count: 60, startingPrice: 18000000 }
      ],
      reviews: [
        { name: 'Ibrahim Koné', profile: 'Grossiste textile, commerçant depuis 20 ans', avatar: '##', rating: 4, date: '13 août 2025', category: 'professionals', comment: 'Adjamé est le paradis du commerce ! On trouve tout à des prix imbattables. La gare routière est très pratique pour les déplacements. Le quartier est animé 24h/24.', tags: ['Commerce', 'Transport', 'Prix'], helpful: 25 },
        { name: 'Mariam Sanogo', profile: 'Infirmière, résidente depuis 7 ans', avatar: '##', rating: 3, date: '7 août 2025', category: 'families', comment: 'Quartier très animé mais parfois bruyant. Les prix de l\'immobilier sont très accessibles. Avec les projets de modernisation en cours, le cadre de vie devrait s\'améliorer.', tags: ['Accessibilité', 'Animation', 'Modernisation'], helpful: 11 }
      ]
    },
    {
      id: 'yopougon',
      name: 'Yopougon',
      shortDescription: 'Plus grande commune résidentielle d\'Abidjan',
      description: 'Commune la plus peuplée avec une forte diversité sociale et de nombreux projets de développement urbain.',
      detailedDescription: `Yopougon est la plus grande commune d'Abidjan en termes de population, un véritable microcosme de la société ivoirienne. Avec plus d'un million d'habitants, cette commune populaire et dynamique est le cœur battant de la classe moyenne abidjanaise.\n\nConnue pour ses maquis animés, sa vie de quartier chaleureuse et son esprit communautaire fort, Yopougon attire de nombreux investisseurs grâce à ses prix immobiliers accessibles et son potentiel de valorisation important. Les nombreux projets d'infrastructure en cours transforment progressivement le visage de cette commune.`,
      heroImage: 'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/YOPOUGON.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvWU9QT1VHT04uUE5HIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4MjIyNTQwOSwiZXhwIjoxODEzNzYxNDA5fQ.USz_I6a1_h41afzSJFxE5Fm-Q0apuAE6yl0WVHAfSyo',
      galleryImages: [
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/YOPPPP.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvWU9QUFBQLlBORyIsInNjb3BlIjoiZG93bmxvYWQiLCJpYXQiOjE3ODIyMjU0NDgsImV4cCI6MTgxMzc2MTQ0OH0.P_C-Ybfy4BlyfNcCJAlbGh7CuiXhqN0HCsOfhbT8j9w',
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/YOPPPP.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvWU9QUFBQLlBORyIsInNjb3BlIjoiZG93bmxvYWQiLCJpYXQiOjE3ODIyMjU0NDgsImV4cCI6MTgxMzc2MTQ0OH0.P_C-Ybfy4BlyfNcCJAlbGh7CuiXhqN0HCsOfhbT8j9w',
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/YOPOUGON.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvWU9QT1VHT04uUE5HIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4MjIyNTUwNiwiZXhwIjoxODEzNzYxNTA2fQ.l9xAkRchN2X7oJVYH2EJ2pgafe5q5rA8LdQFvuzBpqY'
      ],
      population: '1,100,000 hab.',
      area: '152 km²',
      averagePrice: '20M FCFA/m²',
      qualityRating: 4.0,
      propertyCount: 1100,
      isPopular: true,
      keyFeatures: [
        'Plus grande commune d\'Abidjan','Zone industrielle importante','Maquis et vie nocturne populaire','Nombreux projets immobiliers','Prix accessibles classe moyenne','Forte communauté et solidarité'
      ],
      coordinates: { lat: 5.3500, lng: -4.0833 },
      lifestyle: {
        dining: [
          { name: 'Maquis Chez Gnambro', description: 'Institution de la cuisine populaire' },
          { name: 'Restaurant Yopougon City', description: 'Cuisine variée et abordable' },
          { name: 'Grillade du Carrefour', description: 'Spécialités grillées locales' }
        ],
        shopping: [
          { name: 'Marché de Yopougon', description: 'Grand marché populaire' },
          { name: 'Centre Commercial Cosmos', description: 'Shopping moderne' },
          { name: 'Boutiques de Quartier', description: 'Commerce de proximité' }
        ],
        entertainment: [
          { name: 'Maquis Culturels', description: 'Musique et danse populaires' },
          { name: 'Stade de Yopougon', description: 'Football et événements' },
          { name: 'Espaces Communautaires', description: 'Fêtes et célébrations' }
        ],
        sports: [
          { name: 'Stade Municipal', description: 'Football et athlétisme' },
          { name: 'Salles de Sport', description: 'Fitness et musculation' },
          { name: 'Terrains de Proximité', description: 'Sports de quartier' }
        ]
      },
      dailyLifeImages: [
        { url: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop', caption: 'Quartier résidentiel de Yopougon', location: 'Zone résidentielle' },
        { url: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop', caption: 'Immeubles modernes en construction', location: 'Nouveau quartier' },
        { url: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop', caption: 'Villas familiales', location: 'Zone pavillonnaire' }
      ],
      infrastructure: {
        transport: [
          { name: 'Gare Routière de Yopougon', distance: '2 km', rating: 4.1 },
          { name: 'Station BRT Yopougon', distance: '1.5 km', rating: 4.3 },
          { name: 'Aéroport International', distance: '30 km', rating: 4.0 }
        ],
        education: [
          { name: 'Lycée Municipal de Yopougon', distance: '1 km', rating: 4.0 },
          { name: 'Université de Yopougon', distance: '3 km', rating: 4.2 },
          { name: 'Écoles Primaires Publiques', distance: '0.5 km', rating: 3.9 }
        ],
        healthcare: [
          { name: 'Hôpital Général de Yopougon', distance: '3 km', rating: 4.0 },
          { name: 'Clinique Privée', distance: '2 km', rating: 4.2 },
          { name: 'Pharmacies de Quartier', distance: '0.5 km', rating: 4.0 }
        ],
        utilities: [
          { name: 'Agence CIE Yopougon', distance: '2 km', rating: 3.8 },
          { name: 'SODECI Yopougon', distance: '2.5 km', rating: 3.7 },
          { name: 'Bureau de Poste', distance: '1 km', rating: 3.9 }
        ]
      },
      developmentProjects: [
        { name: 'Extension BRT Yopougon', description: 'Nouvelles lignes de bus rapide', status: 'En cours', budget: '80 Mds FCFA', completion: 'Juin 2026' },
        { name: 'Cité Universitaire', description: 'Résidences étudiantes modernes', status: 'Planifié', budget: '60 Mds FCFA', completion: 'Décembre 2026' },
        { name: 'Zone Commerciale Yopougon', description: 'Grand centre commercial moderne', status: 'En cours', budget: '45 Mds FCFA', completion: 'Mars 2026' }
      ],
      commuteData: [
        { name: 'Plateau', type: 'Centre d\'affaires', time: '35 min', mode: 'BRT' },
        { name: 'Adjamé', type: 'Commercial', time: '25 min', mode: 'Gbaka' },
        { name: 'Aéroport International', type: 'Transport', time: '40 min', mode: 'Taxi' },
        { name: 'Zone Industrielle', type: 'Industrie', time: '15 min', mode: 'Voiture' }
      ],
      investment: {
        appreciation: '6.5%',
        rentalYield: '7.8%',
        averageSaleTime: '60 jours',
        rentalDemand: 'Très élevée',
        priceEvolution: [
          { year: '2020', price: 15 },
          { year: '2021', price: 16 },
          { year: '2022', price: 17 },
          { year: '2023', price: 18 },
          { year: '2024', price: 20 }
        ],
        propertyTypes: [
          { name: 'Maisons', value: 45 },
          { name: 'Appartements', value: 35 },
          { name: 'Terrains', value: 15 },
          { name: 'Commerces', value: 5 }
        ],
        opportunities: [
          { type: 'Résidentiel', title: 'Logements Locatifs', description: 'Demande locative très forte', estimatedROI: '11-14%' },
          { type: 'Commercial', title: 'Commerces de Proximité', description: 'Population dense = clientèle assurée', estimatedROI: '10-13%' },
          { type: 'Terrain', title: 'Terrains à Bâtir', description: 'Fort potentiel de valorisation', estimatedROI: '12-16%' }
        ]
      },
      featuredProperties: [
        { title: 'Villa Familiale Yopougon', location: 'Yopougon Résidentiel, quartier calme', image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop', price: 65000000, pricePerSqm: 217000, bedrooms: 4, bathrooms: 3, area: 300, status: 'À vendre', rating: 4.1, hasVideo: false },
        { title: 'Appartement Moderne Yopougon', location: 'Yopougon Centre, résidence sécurisée', image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop', price: 40000000, pricePerSqm: 200000, bedrooms: 3, bathrooms: 2, area: 200, status: 'À vendre', rating: 4.0, hasVideo: false },
        { title: 'Maison F3 Yopougon', location: 'Yopougon, proche marché', image: 'https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=600&h=400&fit=crop', price: 1500000, bedrooms: 3, bathrooms: 1, area: 120, status: 'À louer', rating: 4.0, hasVideo: false }
      ],
      propertyTypes: [
        { name: 'Maisons', description: 'Habitations familiales populaires', icon: 'Home', count: 500, startingPrice: 30000000 },
        { name: 'Appartements', description: 'Logements en immeuble', icon: 'Building', count: 380, startingPrice: 25000000 },
        { name: 'Terrains', description: 'Parcelles à bâtir', icon: 'Square', count: 220, startingPrice: 10000000 }
      ],
      reviews: [
        { name: 'Adjoua Koffi', profile: 'Enseignante, résidente depuis 12 ans', avatar: '##', rating: 4, date: '15 août 2025', category: 'families', comment: 'Yopougon est une commune chaleureuse avec un fort esprit communautaire. Les prix sont très accessibles et les projets en cours vont vraiment améliorer le cadre de vie. Je recommande pour les familles avec un budget moyen.', tags: ['Famille', 'Communauté', 'Accessibilité'], helpful: 30 },
        { name: 'Seydou Bamba', profile: 'Entrepreneur, investisseur immobilier', avatar: '##', rating: 5, date: '10 août 2025', category: 'professionals', comment: 'Excellent potentiel d\'investissement ! Les prix sont encore bas mais la valorisation est forte. Avec l\'extension du BRT et les nouveaux projets, Yopougon va beaucoup se développer dans les prochaines années.', tags: ['Investissement', 'Potentiel', 'Développement'], helpful: 35 }
      ]
    },
    {
      id: 'abobo',
      name: 'Abobo',
      shortDescription: 'Commune résidentielle en expansion rapide',
      description: 'Zone résidentielle dynamique avec de nombreux projets immobiliers et infrastructures en développement.',
      detailedDescription: `Abobo est l'une des communes les plus dynamiques d'Abidjan, en pleine transformation urbaine. Deuxième commune la plus peuplée de la ville, elle attire de nombreuses familles grâce à ses prix immobiliers compétitifs et ses vastes espaces disponibles pour la construction.\n\nLa commune bénéficie d'importants investissements publics dans les infrastructures routières, scolaires et sanitaires. Sa position au nord d'Abidjan en fait un point de passage stratégique pour les échanges avec l'intérieur du pays, favorisant le développement commercial et industriel.`,heroImage: 'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/ABOBOO.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvQUJPQk9PLmpwZyIsInNjb3BlIjoiZG93bmxvYWQiLCJpYXQiOjE3ODIyMjU2MzAsImV4cCI6MTgxMzc2MTYzMH0.Ga1xYygg6ibBeVIotq0vtMeGRkzlJbLdaPemhgjssfI',
      galleryImages: [
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/ABOBO.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvQUJPQk8uanBnIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4MjIyNTY2OCwiZXhwIjoxODEzNzYxNjY4fQ.brPc7E4ZMN3fLkn02GpvBBlEkDsgn8CWLO2YZ8187yY','https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/ABBBOOOB.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvQUJCQk9PT0IuanBnIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4MjIyNTcxMywiZXhwIjoxODEzNzYxNzEzfQ.xfjO_xDD2lyOGL27fCaiCLjW_dZGDhQgak0_eRiw4Rg','https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/ABBBOOOB.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvQUJCQk9PT0IuanBnIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4MjIyNTcxMywiZXhwIjoxODEzNzYxNzEzfQ.xfjO_xDD2lyOGL27fCaiCLjW_dZGDhQgak0_eRiw4Rg'
      ],
      population: '900,000 hab.',area: '120 km²',averagePrice: '16M FCFA/m²',
      qualityRating: 3.8,
      propertyCount: 750,
      isPopular: false,
      keyFeatures: [
        'Vastes terrains disponibles','Prix immobiliers très compétitifs','Projets d\'infrastructure majeurs','Axe nord d\'Abidjan stratégique','Développement commercial croissant','Forte croissance démographique'
      ],
      coordinates: { lat: 5.4167, lng: -4.0167 },
      lifestyle: {
        dining: [
          { name: 'Maquis Populaires Abobo', description: 'Cuisine locale abordable' },
          { name: 'Restaurant Communautaire', description: 'Plats traditionnels variés' },
          { name: 'Snack du Carrefour', description: 'Restauration rapide locale' }
        ],
        shopping: [
          { name: 'Grand Marché d\'Abobo', description: 'Marché populaire bien approvisionné' },
          { name: 'Boutiques de Quartier', description: 'Commerce de proximité' },
          { name: 'Marché Hebdomadaire', description: 'Produits frais et artisanat' }
        ],
        entertainment: [
          { name: 'Stade Municipal Abobo', description: 'Football et événements sportifs' },
          { name: 'Espaces Culturels', description: 'Fêtes communautaires' },
          { name: 'Cinéma de Quartier', description: 'Divertissement local' }
        ],
        sports: [
          { name: 'Stade d\'Abobo', description: 'Football et athlétisme' },
          { name: 'Terrains Multisports', description: 'Basketball et volleyball' },
          { name: 'Espaces Verts', description: 'Jogging et promenades' }
        ]
      },
      dailyLifeImages: [
        { url: 'https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=600&h=400&fit=crop', caption: 'Quartier résidentiel d\'Abobo', location: 'Zone résidentielle' },
        { url: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop', caption: 'Nouvelles constructions', location: 'Zone d\'expansion' },
        { url: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop', caption: 'Maisons familiales', location: 'Quartier pavillonnaire' }
      ],
      infrastructure: {
        transport: [
          { name: 'Gare Routière d\'Abobo', distance: '2 km', rating: 4.0 },
          { name: 'Station BRT Abobo', distance: '1.5 km', rating: 4.2 },
          { name: 'Axe Autoroute Nord', distance: '3 km', rating: 4.4 }
        ],
        education: [
          { name: 'Lycée Municipal d\'Abobo', distance: '1.5 km', rating: 3.8 },
          { name: 'Écoles Primaires', distance: '0.5 km', rating: 3.7 },
          { name: 'Centre de Formation Pro', distance: '2 km', rating: 3.9 }
        ],
        healthcare: [
          { name: 'Hôpital d\'Abobo', distance: '3 km', rating: 3.7 },
          { name: 'Centre de Santé', distance: '1.5 km', rating: 3.6 },
          { name: 'Pharmacies', distance: '0.5 km', rating: 3.9 }
        ],
        utilities: [
          { name: 'Agence CIE Abobo', distance: '2 km', rating: 3.6 },
          { name: 'SODECI Abobo', distance: '2.5 km', rating: 3.5 },
          { name: 'Bureau de Poste', distance: '1.5 km', rating: 3.7 }
        ]
      },
      developmentProjects: [
        { name: 'Autoroute Abobo-Anyama', description: 'Désengorgement du trafic nord', status: 'En cours', budget: '100 Mds FCFA', completion: 'Décembre 2026' },
        { name: 'Hôpital Moderne Abobo', description: 'Nouveau centre hospitalier', status: 'Planifié', budget: '70 Mds FCFA', completion: 'Juin 2027' },
        { name: 'Cité Résidentielle Abobo', description: '5000 logements sociaux', status: 'En cours', budget: '120 Mds FCFA', completion: 'Mars 2027' }
      ],
      commuteData: [
        { name: 'Plateau', type: 'Centre d\'affaires', time: '40 min', mode: 'BRT' },
        { name: 'Adjamé', type: 'Commercial', time: '20 min', mode: 'Woro-woro' },
        { name: 'Anyama', type: 'Périphérie', time: '15 min', mode: 'Voiture' },
        { name: 'Aéroport', type: 'Transport', time: '45 min', mode: 'Taxi' }
      ],
      investment: {
        appreciation: '7.0%',
        rentalYield: '8.5%',
        averageSaleTime: '65 jours',
        rentalDemand: 'Élevée',
        priceEvolution: [
          { year: '2020', price: 11 },
          { year: '2021', price: 12 },
          { year: '2022', price: 13 },
          { year: '2023', price: 14 },
          { year: '2024', price: 16 }
        ],
        propertyTypes: [
          { name: 'Maisons', value: 55 },
          { name: 'Terrains', value: 25 },
          { name: 'Appartements', value: 20 }
        ],
        opportunities: [
          { type: 'Terrain', title: 'Terrains à Fort Potentiel', description: 'Prix bas, valorisation rapide', estimatedROI: '15-20%' },
          { type: 'Résidentiel', title: 'Logements Sociaux', description: 'Demande massive non satisfaite', estimatedROI: '10-13%' },
          { type: 'Commercial', title: 'Commerces de Proximité', description: 'Population en forte croissance', estimatedROI: '11-14%' }
        ]
      },
      featuredProperties: [
        { title: 'Terrain Viabilisé Abobo', location: 'Abobo, zone en développement', image: 'https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=600&h=400&fit=crop', price: 25000000, pricePerSqm: 50000, bedrooms: 0, bathrooms: 0, area: 500, status: 'À vendre', rating: 4.0, hasVideo: false },
        { title: 'Maison Familiale Abobo', location: 'Abobo Résidentiel', image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop', price: 45000000, pricePerSqm: 150000, bedrooms: 4, bathrooms: 2, area: 300, status: 'À vendre', rating: 3.9, hasVideo: false },
        { title: 'Appartement F3 Abobo', location: 'Abobo Centre', image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop', price: 1200000, bedrooms: 3, bathrooms: 1, area: 100, status: 'À louer', rating: 3.8, hasVideo: false }
      ],
      propertyTypes: [
        { name: 'Maisons', description: 'Habitations familiales spacieuses', icon: 'Home', count: 400, startingPrice: 25000000 },
        { name: 'Terrains', description: 'Parcelles à bâtir à prix compétitifs', icon: 'Square', count: 250, startingPrice: 8000000 },
        { name: 'Appartements', description: 'Logements en immeuble', icon: 'Building', count: 100, startingPrice: 20000000 }
      ],
      reviews: [
        { name: 'Bintou Diarra', profile: 'Institutrice, résidente depuis 8 ans', avatar: '##', rating: 4, date: '14 août 2025', category: 'families', comment: 'Abobo est une commune en pleine évolution. Les prix sont très accessibles et les projets d\'infrastructure vont vraiment changer les choses. Idéal pour les familles qui veulent construire leur maison.', tags: ['Famille', 'Construction', 'Accessibilité'], helpful: 20 },
        { name: 'Lamine Coulibaly', profile: 'Promoteur immobilier', avatar: '##', rating: 5, date: '8 août 2025', category: 'professionals', comment: 'Abobo est la commune avec le meilleur potentiel d\'investissement d\'Abidjan actuellement. Les terrains sont encore abordables et la valorisation sera très forte avec les nouveaux projets.', tags: ['Investissement', 'Terrains', 'Potentiel'], helpful: 32 }
      ]
    },
    {
      id: 'koumassi',
      name: 'Koumassi',
      shortDescription: 'Quartier industriel et résidentiel mixte',
      description: 'Commune industrielle importante avec développement résidentiel croissant et bonnes connexions de transport.',
      detailedDescription: `Koumassi est une commune à double visage : industrielle et résidentielle, elle offre un équilibre unique entre zones d'activités économiques et quartiers d'habitation. Sa position géographique centrale dans le Grand Abidjan en fait un nœud de communication important.\n\nLa commune abrite de nombreuses industries légères et zones d'activités qui créent un bassin d'emploi local important. Les quartiers résidentiels de Koumassi, en plein développement, offrent des opportunités immobilières intéressantes à des prix encore compétitifs.`,
      heroImage: 'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/KOUMASSI.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvS09VTUFTU0kuUE5HIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4MjIyNjU3MCwiZXhwIjoxODEzNzYyNTcwfQ.e6Zys0B0Ipr-h2CdQ6EfLdOamW41icdIL1rtfOrx4us',
      galleryImages: [
        'https://rwtsvvpklmosipnatufe.supabase.co/storage/v1/object/sign/communes-images/ALLCOMMUNES/KOUMASSI.PNG?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9lM2I2N2NhZi05ZjM3LTRkNWYtYTFkYi1mZWZkNWM4ZjYzZjgiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb21tdW5lcy1pbWFnZXMvQUxMQ09NTVVORVMvS09VTUFTU0kuUE5HIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4MjIyNjU3MCwiZXhwIjoxODEzNzYyNTcwfQ.e6Zys0B0Ipr-h2CdQ6EfLdOamW41icdIL1rtfOrx4us',
        'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop',
        'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop'
      ],
      population: '320,000 hab.',
      area: '18 km²',
      averagePrice: '22M FCFA/m²',
      qualityRating: 4.0,
      propertyCount: 520,
      isPopular: false,
      keyFeatures: [
        'Zone industrielle active','Résidentiel en développement','Bonne connexion transport','Emplois locaux nombreux','Prix immobiliers compétitifs','Projets de modernisation en cours'
      ],
      coordinates: { lat: 5.3000, lng: -3.9667 },
      lifestyle: {
        dining: [
          { name: 'Restaurant des Travailleurs', description: 'Cuisine locale pour ouvriers et cadres' },
          { name: 'Maquis Koumassi', description: 'Spécialités ivoiriennes populaires' },
          { name: 'Fast Food Industriel', description: 'Restauration rapide et pratique' }
        ],
        shopping: [
          { name: 'Marché de Koumassi', description: 'Marché populaire bien fourni' },
          { name: 'Boutiques Industrielles', description: 'Matériaux et équipements' },
          { name: 'Supermarché Local', description: 'Grande surface de proximité' }
        ],
        entertainment: [
          { name: 'Stade de Koumassi', description: 'Football et sports' },
          { name: 'Espaces Verts', description: 'Détente et loisirs' },
          { name: 'Clubs de Quartier', description: 'Vie sociale locale' }
        ],
        sports: [
          { name: 'Stade Municipal', description: 'Football et athlétisme' },
          { name: 'Salle de Sport', description: 'Fitness et musculation' },
          { name: 'Terrain Multisports', description: 'Sports collectifs' }
        ]
      },
      dailyLifeImages: [
        { url: 'https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=600&h=400&fit=crop', caption: 'Zone industrielle de Koumassi', location: 'Zone industrielle' },
        { url: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop', caption: 'Quartier résidentiel', location: 'Zone résidentielle' },
        { url: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop', caption: 'Immeubles modernes', location: 'Nouveau quartier' }
      ],
      infrastructure: {
        transport: [
          { name: 'Gare Routière Koumassi', distance: '1.5 km', rating: 4.1 },
          { name: 'Station BRT Koumassi', distance: '1 km', rating: 4.3 },
          { name: 'Accès Autoroute', distance: '2 km', rating: 4.2 }
        ],
        education: [
          { name: 'Lycée de Koumassi', distance: '1 km', rating: 4.0 },
          { name: 'École Primaire', distance: '0.5 km', rating: 3.9 },
          { name: 'Centre de Formation Pro', distance: '1.5 km', rating: 4.1 }
        ],
        healthcare: [
          { name: 'Hôpital de Koumassi', distance: '2 km', rating: 4.0 },
          { name: 'Infirmerie Industrielle', distance: '1 km', rating: 3.9 },
          { name: 'Pharmacies', distance: '0.5 km', rating: 4.0 }
        ],
        utilities: [
          { name: 'Agence CIE Koumassi', distance: '1.5 km', rating: 3.9 },
          { name: 'SODECI Koumassi', distance: '2 km', rating: 3.8 },
          { name: 'Bureau de Poste', distance: '1 km', rating: 4.0 }
        ]
      },
      developmentProjects: [
        { name: 'Extension Zone Industrielle', description: 'Nouvelles unités de production', status: 'En cours', budget: '55 Mds FCFA', completion: 'Juin 2026' },
        { name: 'Résidences Ouvrières Modernes', description: 'Logements pour travailleurs', status: 'Planifié', budget: '40 Mds FCFA', completion: 'Décembre 2026' },
        { name: 'Voie de Contournement', description: 'Réduction des embouteillages', status: 'En cours', budget: '30 Mds FCFA', completion: 'Mars 2026' }
      ],
      commuteData: [
        { name: 'Plateau', type: 'Centre d\'affaires', time: '25 min', mode: 'BRT' },
        { name: 'Marcory', type: 'Résidentiel', time: '10 min', mode: 'Taxi' },
        { name: 'Port Autonome', type: 'Zone industrielle', time: '10 min', mode: 'Voiture' },
        { name: 'Aéroport', type: 'Transport', time: '20 min', mode: 'Taxi' }
      ],
      investment: {
        appreciation: '6.8%',
        rentalYield: '7.5%',
        averageSaleTime: '58 jours',
        rentalDemand: 'Élevée',
        priceEvolution: [
          { year: '2020', price: 16 },
          { year: '2021', price: 17 },
          { year: '2022', price: 19 },
          { year: '2023', price: 20 },
          { year: '2024', price: 22 }
        ],
        propertyTypes: [
          { name: 'Appartements', value: 40 },
          { name: 'Maisons', value: 35 },
          { name: 'Industriel', value: 15 },
          { name: 'Commerces', value: 10 }
        ],
        opportunities: [
          { type: 'Industriel', title: 'Entrepôts et Ateliers', description: 'Forte demande des PME industrielles', estimatedROI: '12-15%' },
          { type: 'Résidentiel', title: 'Logements Ouvriers', description: 'Demande locative soutenue', estimatedROI: '10-13%' },
          { type: 'Commercial', title: 'Services aux Entreprises', description: 'Croissance du tissu industriel', estimatedROI: '9-12%' }
        ]
      },
      featuredProperties: [
        { title: 'Entrepôt Industriel Koumassi', location: 'Koumassi Zone Industrielle', image: 'https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=600&h=400&fit=crop', price: 80000000, pricePerSqm: 160000, bedrooms: 0, bathrooms: 2, area: 500, status: 'À vendre', rating: 4.2, hasVideo: false },
        { title: 'Appartement Résidentiel', location: 'Koumassi Résidentiel', image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop', price: 45000000, pricePerSqm: 225000, bedrooms: 3, bathrooms: 2, area: 200, status: 'À vendre', rating: 4.0, hasVideo: false },
        { title: 'Studio Meublé Koumassi', location: 'Koumassi Centre', image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop', price: 1500000, bedrooms: 1, bathrooms: 1, area: 45, status: 'À louer', rating: 3.9, hasVideo: false }
      ],
      propertyTypes: [
        { name: 'Appartements', description: 'Logements résidentiels modernes', icon: 'Building', count: 210, startingPrice: 30000000 },
        { name: 'Maisons', description: 'Habitations familiales', icon: 'Home', count: 180, startingPrice: 35000000 },
        { name: 'Industriel', description: 'Entrepôts et ateliers', icon: 'Building2', count: 130, startingPrice: 50000000 }
      ],
      reviews: [
        { name: 'Drissa Ouattara', profile: 'Contremaître, résident depuis 9 ans', avatar: '##', rating: 4, date: '13 août 2025', category: 'professionals', comment: 'Koumassi est idéal pour les travailleurs de l\'industrie. Tout est proche du lieu de travail et les prix sont raisonnables. La commune se modernise progressivement.', tags: ['Travail', 'Proximité', 'Modernisation'], helpful: 15 },
        { name: 'Clarisse Yao', profile: 'Comptable, famille avec 2 enfants', avatar: '##', rating: 4, date: '9 août 2025', category: 'families', comment: 'Bonne commune pour vivre et travailler. Les écoles sont correctes et les transports bien organisés. Le cadre de vie s\'améliore avec les nouveaux projets.', tags: ['Famille', 'Transport', 'Cadre de vie'], helpful: 13 }
      ]
    },
    {
      id: 'port-bouet',
      name: 'Port-Bouët',
      shortDescription: 'Zone aéroportuaire et balnéaire',
      description: 'Commune stratégique abritant l\'aéroport international et les plus belles plages d\'Abidjan.',
      detailedDescription: `Port-Bouët est une commune unique à Abidjan, combinant la modernité de l'aéroport international Félix Houphouët-Boigny avec le charme balnéaire de ses plages de l'Atlantique. Cette dualité en fait l'une des communes les plus attractives pour les investisseurs et les résidents en quête d'un cadre de vie exceptionnel.\n\nLes plages de Port-Bouët, notamment la plage de Vridi et la plage de l'Hôtel Ivoire, sont les plus fréquentées d'Abidjan. La présence de l'aéroport international génère une forte demande en logements pour les professionnels de l'aviation et les expatriés en transit.`,
      heroImage: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&h=600&fit=crop',
      galleryImages: [
        'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600&h=400&fit=crop',
        'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=600&h=400&fit=crop',
        'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&h=400&fit=crop'
      ],
      population: '200,000 hab.',
      area: '45 km²',
      averagePrice: '30M FCFA/m²',
      qualityRating: 4.3,
      propertyCount: 340,
      isPopular: false,
      keyFeatures: [
        'Aéroport International Félix HB','Plages de l\'Atlantique','Zone franche industrielle','Hôtels et resorts balnéaires','Communauté expatriée importante','Développement touristique en cours'
      ],
      coordinates: { lat: 5.2544, lng: -3.9267 },
      lifestyle: {
        dining: [
          { name: 'Restaurant Bord de Mer', description: 'Fruits de mer et cuisine internationale' },
          { name: 'Beach Bar Vridi', description: 'Cocktails et grillades sur la plage' },
          { name: 'Restaurant Aéroport', description: 'Cuisine internationale 24h/24' }
        ],
        shopping: [
          { name: 'Duty Free Aéroport', description: 'Shopping hors taxes international' },
          { name: 'Marché de Port-Bouët', description: 'Produits locaux et artisanat' },
          { name: 'Boutiques Hôtels', description: 'Souvenirs et produits de luxe' }
        ],
        entertainment: [
          { name: 'Plages de Vridi', description: 'Baignade et sports nautiques' },
          { name: 'Club Nautique', description: 'Voile et sports aquatiques' },
          { name: 'Hôtels Balnéaires', description: 'Piscines et spas' }
        ],
        sports: [
          { name: 'Sports Nautiques', description: 'Surf, jet-ski, plongée' },
          { name: 'Beach Volley', description: 'Tournois sur la plage' },
          { name: 'Golf Club Balnéaire', description: 'Parcours avec vue mer' }
        ]
      },
      dailyLifeImages: [
        { url: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600&h=400&fit=crop', caption: 'Plages de Port-Bouët', location: 'Plage de Vridi' },
        { url: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=600&h=400&fit=crop', caption: 'Aéroport International', location: 'Aéroport FHB' },
        { url: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&h=400&fit=crop', caption: 'Bord de mer et loisirs', location: 'Front de mer' }
      ],
      infrastructure: {
        transport: [
          { name: 'Aéroport International FHB', distance: '2 km', rating: 4.8 },
          { name: 'Port Autonome d\'Abidjan', distance: '5 km', rating: 4.5 },
          { name: 'Gare Routière Port-Bouët', distance: '3 km', rating: 4.0 }
        ],
        education: [
          { name: 'Lycée de Port-Bouët', distance: '2 km', rating: 4.0 },
          { name: 'École Internationale', distance: '3 km', rating: 4.5 },
          { name: 'Centre de Formation Aviation', distance: '1 km', rating: 4.6 }
        ],
        healthcare: [
          { name: 'Clinique Aéroportuaire', distance: '1 km', rating: 4.5 },
          { name: 'Hôpital de Port-Bouët', distance: '3 km', rating: 4.0 },
          { name: 'Pharmacies', distance: '1 km', rating: 4.2 }
        ],
        utilities: [
          { name: 'Agence CIE Port-Bouët', distance: '2 km', rating: 4.0 },
          { name: 'SODECI Port-Bouët', distance: '2.5 km', rating: 3.9 },
          { name: 'Bureau de Poste', distance: '2 km', rating: 4.0 }
        ]
      },
      developmentProjects: [
        { name: 'Extension Aéroport FHB', description: 'Nouveau terminal international', status: 'En cours', budget: '500 Mds FCFA', completion: 'Décembre 2027' },
        { name: 'Resort Balnéaire Vridi', description: 'Complexe hôtelier 5 étoiles', status: 'Planifié', budget: '150 Mds FCFA', completion: 'Juin 2027' },
        { name: 'Zone Franche Aéroportuaire', description: 'Hub logistique et commercial', status: 'En cours', budget: '200 Mds FCFA', completion: 'Mars 2026' }
      ],
      commuteData: [
        { name: 'Plateau', type: 'Centre d\'affaires', time: '30 min', mode: 'Voiture' },
        { name: 'Marcory', type: 'Résidentiel', time: '20 min', mode: 'Taxi' },
        { name: 'Treichville', type: 'Commercial', time: '25 min', mode: 'Taxi' },
        { name: 'Aéroport', type: 'Transport', time: '5 min', mode: 'Voiture' }
      ],
      investment: {
        appreciation: '8.0%',
        rentalYield: '6.5%',
        averageSaleTime: '50 jours',
        rentalDemand: 'Élevée',
        priceEvolution: [
          { year: '2020', price: 22 },
          { year: '2021', price: 24 },
          { year: '2022', price: 26 },
          { year: '2023', price: 28 },
          { year: '2024', price: 30 }
        ],
        propertyTypes: [
          { name: 'Villas Balnéaires', value: 35 },
          { name: 'Appartements', value: 40 },
          { name: 'Hôtels/Résidences', value: 15 },
          { name: 'Commerces', value: 10 }
        ],
        opportunities: [
          { type: 'Touristique', title: 'Résidences Balnéaires', description: 'Tourisme en forte croissance', estimatedROI: '12-16%' },
          { type: 'Résidentiel', title: 'Logements Expatriés', description: 'Forte demande aéroportuaire', estimatedROI: '10-14%' },
          { type: 'Commercial', title: 'Services Aéroportuaires', description: 'Croissance du trafic aérien', estimatedROI: '11-15%' }
        ]
      },
      featuredProperties: [
        { title: 'Villa Balnéaire Vridi', location: 'Port-Bouët, bord de mer', image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600&h=400&fit=crop', price: 150000000, pricePerSqm: 375000, bedrooms: 4, bathrooms: 3, area: 400, status: 'À vendre', rating: 4.6, hasVideo: false },
        { title: 'Appartement Vue Mer', location: 'Port-Bouët, résidence balnéaire', image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&h=400&fit=crop', price: 75000000, pricePerSqm: 375000, bedrooms: 3, bathrooms: 2, area: 200, status: 'À vendre', rating: 4.4, hasVideo: false },
        { title: 'Studio Aéroportuaire', location: 'Port-Bouët, proche aéroport', image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop', price: 2500000, bedrooms: 1, bathrooms: 1, area: 55, status: 'À louer', rating: 4.3, hasVideo: false }
      ],
      propertyTypes: [
        { name: 'Villas Balnéaires', description: 'Résidences luxueuses bord de mer', icon: 'Home', count: 120, startingPrice: 100000000 },
        { name: 'Appartements', description: 'Logements modernes avec vue mer', icon: 'Building', count: 150, startingPrice: 50000000 },
        { name: 'Résidences Hôtelières', description: 'Investissement locatif touristique', icon: 'Building2', count: 70, startingPrice: 80000000 }
      ],
      reviews: [
        { name: 'Laurent Dupont', profile: 'Pilote de ligne, expatrié français', avatar: '##', rating: 5, date: '16 août 2025', category: 'professionals', comment: 'Port-Bouët est parfait pour les professionnels de l\'aviation. La proximité de l\'aéroport est un atout majeur et les plages sont magnifiques. Le cadre de vie est exceptionnel pour une commune africaine.', tags: ['Aéroport', 'Plages', 'Expatriés'], helpful: 27 },
        { name: 'Nathalie Konan', profile: 'Hôtelière, résidente depuis 6 ans', avatar: '##', rating: 4, date: '11 août 2025', category: 'professionals', comment: 'Excellent potentiel touristique ! Les plages de Vridi sont superbes et le développement hôtelier est en plein essor. Idéal pour investir dans l\'immobilier touristique.', tags: ['Tourisme', 'Plages', 'Investissement'], helpful: 21 }
      ]
    },
    {
      id: 'attécoubé',
      name: 'Attécoubé',
      shortDescription: 'Commune résidentielle émergente',
      description: 'Zone résidentielle en développement avec de nouveaux projets immobiliers et infrastructures modernes.',
      detailedDescription: `Attécoubé est une commune en pleine émergence, bénéficiant d'une position géographique privilégiée entre le Plateau et les communes nord d'Abidjan. Longtemps méconnue, elle connaît aujourd'hui un développement immobilier accéléré qui attire de plus en plus d'investisseurs et de familles.\n\nLa commune se distingue par ses collines offrant des vues panoramiques sur la lagune Ébrié, ses quartiers résidentiels en développement et ses prix encore accessibles. Les projets d'infrastructure en cours vont considérablement améliorer sa connectivité avec le reste d'Abidjan.`,
      heroImage: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1200&h=600&fit=crop',
      galleryImages: [
        'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=600&h=400&fit=crop',
        'https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=600&h=400&fit=crop',
        'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop'
      ],
      population: '180,000 hab.',
      area: '22 km²',
      averagePrice: '18M FCFA/m²',
      qualityRating: 3.9,
      propertyCount: 290,
      isPopular: false,
      keyFeatures: [
        'Vues panoramiques sur la lagune','Quartiers résidentiels calmes','Prix immobiliers accessibles','Projets d\'infrastructure en cours','Proximité du Plateau','Environnement verdoyant'
      ],
      coordinates: { lat: 5.3500, lng: -4.0333 },
      lifestyle: {
        dining: [
          { name: 'Maquis Collines d\'Attécoubé', description: 'Vue panoramique et cuisine locale' },
          { name: 'Restaurant Familial', description: 'Cuisine ivoirienne traditionnelle' },
          { name: 'Snack du Quartier', description: 'Restauration rapide locale' }
        ],
        shopping: [
          { name: 'Marché d\'Attécoubé', description: 'Marché de quartier bien fourni' },
          { name: 'Boutiques Locales', description: 'Commerce de proximité' },
          { name: 'Épiceries de Quartier', description: 'Produits du quotidien' }
        ],
        entertainment: [
          { name: 'Promenade Bord de Lagune', description: 'Vue et détente en famille' },
          { name: 'Espaces Verts', description: 'Parcs et jardins' },
          { name: 'Terrains de Sport', description: 'Football et loisirs' }
        ],
        sports: [
          { name: 'Terrain Municipal', description: 'Football et sports collectifs' },
          { name: 'Jogging Collines', description: 'Parcours sportif avec vue' },
          { name: 'Salle Communautaire', description: 'Fitness et activités' }
        ]
      },
      dailyLifeImages: [
        { url: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=600&h=400&fit=crop', caption: 'Vue panoramique sur la lagune', location: 'Collines d\'Attécoubé' },
        { url: 'https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=600&h=400&fit=crop', caption: 'Quartier résidentiel calme', location: 'Zone résidentielle' },
        { url: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop', caption: 'Villas en construction', location: 'Nouveau quartier' }
      ],
      infrastructure: {
        transport: [
          { name: 'Gare Routière Attécoubé', distance: '2 km', rating: 3.9 },
          { name: 'Station Bus Attécoubé', distance: '1.5 km', rating: 4.0 },
          { name: 'Accès Plateau', distance: '5 km', rating: 4.1 }
        ],
        education: [
          { name: 'Lycée d\'Attécoubé', distance: '1.5 km', rating: 3.9 },
          { name: 'Écoles Primaires', distance: '0.5 km', rating: 3.8 },
          { name: 'Centre de Formation', distance: '2 km', rating: 3.9 }
        ],
        healthcare: [
          { name: 'Centre de Santé Attécoubé', distance: '2 km', rating: 3.8 },
          { name: 'Dispensaire Municipal', distance: '1 km', rating: 3.7 },
          { name: 'Pharmacies', distance: '0.8 km', rating: 3.9 }
        ],
        utilities: [
          { name: 'Agence CIE Attécoubé', distance: '2 km', rating: 3.7 },
          { name: 'SODECI Attécoubé', distance: '2.5 km', rating: 3.6 },
          { name: 'Bureau de Poste', distance: '1.5 km', rating: 3.8 }
        ]
      },
      developmentProjects: [
        { name: 'Route Panoramique Attécoubé', description: 'Nouvelle voie avec vue lagune', status: 'En cours', budget: '20 Mds FCFA', completion: 'Juin 2026' },
        { name: 'Résidences Collines', description: 'Villas haut standing avec vue', status: 'Planifié', budget: '60 Mds FCFA', completion: 'Décembre 2026' },
        { name: 'Pont Attécoubé-Plateau', description: 'Connexion directe au centre', status: 'Planifié', budget: '80 Mds FCFA', completion: 'Juin 2028' }
      ],
      commuteData: [
        { name: 'Plateau', type: 'Centre d\'affaires', time: '20 min', mode: 'Voiture' },
        { name: 'Adjamé', type: 'Commercial', time: '15 min', mode: 'Taxi' },
        { name: 'Cocody', type: 'Résidentiel', time: '25 min', mode: 'Voiture' },
        { name: 'Aéroport', type: 'Transport', time: '35 min', mode: 'Taxi' }
      ],
      investment: {
        appreciation: '7.5%',
        rentalYield: '7.0%',
        averageSaleTime: '72 jours',
        rentalDemand: 'Modérée',
        priceEvolution: [
          { year: '2020', price: 12 },
          { year: '2021', price: 13 },
          { year: '2022', price: 15 },
          { year: '2023', price: 16 },
          { year: '2024', price: 18 }
        ],
        propertyTypes: [
          { name: 'Villas', value: 40 },
          { name: 'Terrains', value: 35 },
          { name: 'Appartements', value: 25 }
        ],
        opportunities: [
          { type: 'Résidentiel', title: 'Villas Vue Lagune', description: 'Rareté des terrains avec vue', estimatedROI: '13-17%' },
          { type: 'Terrain', title: 'Terrains Collines', description: 'Fort potentiel de valorisation', estimatedROI: '15-20%' },
          { type: 'Mixte', title: 'Résidences Panoramiques', description: 'Niche premium en développement', estimatedROI: '12-16%' }
        ]
      },
      featuredProperties: [
        { title: 'Villa Vue Lagune Attécoubé', location: 'Attécoubé Collines, vue panoramique', image: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=600&h=400&fit=crop', price: 90000000, pricePerSqm: 300000, bedrooms: 4, bathrooms: 3, area: 300, status: 'À vendre', rating: 4.4, hasVideo: false },
        { title: 'Terrain Panoramique', location: 'Attécoubé, vue sur lagune', image: 'https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=600&h=400&fit=crop', price: 35000000, pricePerSqm: 70000, bedrooms: 0, bathrooms: 0, area: 500, status: 'À vendre', rating: 4.2, hasVideo: false },
        { title: 'Appartement Calme Attécoubé', location: 'Attécoubé Résidentiel', image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop', price: 1800000, bedrooms: 2, bathrooms: 1, area: 90, status: 'À louer', rating: 4.0, hasVideo: false }
      ],
      propertyTypes: [
        { name: 'Villas', description: 'Résidences avec vue panoramique', icon: 'Home', count: 110, startingPrice: 60000000 },
        { name: 'Terrains', description: 'Parcelles avec vue sur lagune', icon: 'Square', count: 120, startingPrice: 20000000 },
        { name: 'Appartements', description: 'Logements résidentiels calmes', icon: 'Building', count: 60, startingPrice: 25000000 }
      ],
      reviews: [
        { name: 'Cécile Ahoua', profile: 'Architecte, résidente depuis 4 ans', avatar: '##', rating: 5, date: '15 août 2025', category: 'professionals', comment: 'Attécoubé est un vrai secret bien gardé d\'Abidjan ! Les vues sur la lagune sont magnifiques et le calme est appréciable. Les prix sont encore accessibles mais ça ne va pas durer avec les projets en cours.', tags: ['Vue lagune', 'Calme', 'Potentiel'], helpful: 18 },
        { name: 'Hervé Kouamé', profile: 'Investisseur immobilier', avatar: '##', rating: 5, date: '10 août 2025', category: 'professionals', comment: 'J\'ai investi dans plusieurs terrains à Attécoubé et je ne regrette pas. La valorisation est excellente et le projet de pont va révolutionner l\'accessibilité de la commune. À surveiller de près !', tags: ['Investissement', 'Terrains', 'Valorisation'], helpful: 24 }
      ]
    }
  ];

  // Auto-select first commune on load
  useEffect(() => {
    if (communes?.length > 0 && !selectedCommune) {
      setSelectedCommune(communes?.[0]);
    }
  }, [communes, selectedCommune]);

  const handleCommuneSelect = (commune) => {
    setSelectedCommune(commune);
    // Scroll to hero section
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleExploreProperties = () => {
    // Navigate to property search with commune filter
    window.location.href = '/property-search-listings';
  };

  const handleStartTour = () => {
    setTourStartTrigger(prev => prev + 1);
    const section = document.getElementById('immersive-tours-section');
    if (section) {
      section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <Helmet>
        <title>Explorateur de Communes - AbidjanEstate | Guide Complet des Quartiers d'Abidjan</title>
        <meta name="description" content="Découvrez les communes d'Abidjan avec notre guide complet : lifestyle, infrastructure, investissement et avis résidents. Trouvez votre quartier idéal." />
        <meta name="keywords" content="communes Abidjan, quartiers Abidjan, Cocody, Plateau, guide immobilier, investissement Abidjan" />
        <meta property="og:title" content="Explorateur de Communes - Guide des Quartiers d'Abidjan" />
        <meta property="og:description" content="Guide complet des communes d'Abidjan avec analyses d'investissement, lifestyle et avis résidents." />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="homepage-premium-bg min-h-screen">
        {/* Premium Background Layer */}
        <div className="homepage-bg-layer" aria-hidden="true">
          <div className="homepage-mesh-base" />
          <div className="homepage-orb homepage-orb-green-tl" />
          <div className="homepage-orb homepage-orb-blue-tr" />
          <div className="homepage-orb homepage-orb-green-ml" />
          <div className="homepage-orb homepage-orb-blue-br" />
          <div className="homepage-orb homepage-orb-center" />
          <div className="homepage-streak homepage-streak-1" />
          <div className="homepage-streak homepage-streak-2" />
        </div>

        <Header />
        
        <main className="relative z-10">
          {/* Hero Section */}
          <CommuneHero 
            selectedCommune={selectedCommune}
            onExploreProperties={handleExploreProperties}
            onStartTour={handleStartTour}
          />
          
          {/* Commune Selector */}
          <div className="homepage-section-glass">
            <CommuneSelector
              communes={communes}
              selectedCommune={selectedCommune}
              onCommuneSelect={handleCommuneSelect}
            />
          </div>
          
          {/* Commune Content - Only show if commune is selected and has full data */}
          {selectedCommune && selectedCommune?.detailedDescription && (
            <>
              {/* Overview Section */}
              <div className="homepage-section-clear">
                <CommuneOverview commune={selectedCommune} />
              </div>
              
              {/* Lifestyle Section */}
              <div className="homepage-section-glass">
                <LifestyleSection commune={selectedCommune} />
              </div>
              
              {/* Infrastructure Section */}
              <div className="homepage-section-clear">
                <InfrastructureSection commune={selectedCommune} />
              </div>

              {/* Immersive Tours Section */}
              <div id="immersive-tours-section" className="homepage-section-glass">
                <ImmersiveTours commune={selectedCommune} autoStartTrigger={tourStartTrigger} />
              </div>
              
              {/* Investment Insights */}
              <div className="homepage-section-glass">
                <InvestmentInsights commune={selectedCommune} />
              </div>
              
              {/* Property Showcase */}
              <div className="homepage-section-clear">
                <PropertyShowcase commune={selectedCommune} />
              </div>
              
              {/* Resident Reviews */}
              <div className="homepage-section-glass">
                <ResidentReviews commune={selectedCommune} />
              </div>
            </>
          )}
          
          {/* Default message when no detailed data available */}
          {selectedCommune && !selectedCommune?.detailedDescription && (
            <div className="homepage-section-glass py-8">
              <div className="max-w-7xl mx-auto px-4 lg:px-6">
                <EmptyState
                  iconName="MapPin"
                  title="Guide Détaillé Bientôt Disponible"
                  description={`Nous préparons un guide complet pour ${selectedCommune?.name} avec toutes les informations sur le lifestyle, l'infrastructure et les opportunités d'investissement.`}
                  ctaLabel="Explorer les Propriétés"
                  ctaIcon="ArrowRight"
                  onCta={handleExploreProperties}
                  size="lg"
                />
              </div>
            </div>
          )}
        </main>
      </div>
    </>
  );
};

export default CommuneExplorer;